import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 72px;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  pointer-events: auto;\n\n  .left-align {\n    display: flex;\n    max-width: 788px;\n    flex-direction: column;\n    flex: 1;\n    pointer-events: auto;\n\n    > p {\n      color: #fff;\n      font-size: 20px;\n      font-weight: 700;\n      line-height: 30px;\n      margin-bottom: 20px;\n    }\n\n    .image-list {\n      flex-grow: 1;\n      display: flex;\n      flex-direction: column;\n      overflow-y: auto;\n      height: calc(100vh - 120px);\n      gap: 20px;\n      overscroll-behavior: contain;\n      width: 100%;\n    }\n  }\n\n  .cart-wrapper {\n    width: 340px;\n    max-width: 340px;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    pointer-events: auto;\n    align-self: center;\n    height: fit-content;\n    overflow: hidden;\n\n    > section {\n      margin-top: 40px;\n      width: 100%;\n      max-width: 100%;\n    }\n\n    > div {\n      width: 100%;\n      max-width: 100%;\n\n      :first-of-type {\n        position: relative;\n      }\n    }\n  }\n\n  .close-button {\n    all: unset;\n    position: absolute;\n    top: 20px;\n    right: 0;\n    padding: 8px;\n    background-color: white;\n    border-radius: 6px;\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DefaultLoadingContainer } from "@/components/DefaultLoadingContainer";
import Icon from "@/components/icon/Icon";
import { Close } from "@/components/icon/IconList";
import PurchaseSection from "@/components/Package/PurchaseSection";
import { useAuthStore } from "@/lib/auth/AuthStore";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { PriceSection } from "@/modules/products/components/PriceSection";
import { styled as muiStyled, Typography } from "@mui/material";
import Image from "next/image";
import React from "react";
import { isBooksProduct } from "src/api/booksProducts";
import styled from "styled-components";
import useHandoutProductStore from "../../../store/relatedProduct";
export const PreviewBookModal = (param)=>{
    let { onClose  } = param;
    var _source_images, _source_images1, _source_images2;
    const { isLoggedIn , user: { hasUsableFreepass  }  } = useAuthStore();
    const { currentProduct , freeTrialData , isFreeTrialLoading  } = useHandoutProductStore((state)=>({
            currentProduct: state.currentProduct,
            freeTrialData: state.freeTrialData,
            isFreeTrialLoading: state.isFreeTrialLoading
        }));
    const source = currentProduct.source;
    const productType = isBooksProduct(currentProduct) ? currentProduct.productType : currentProduct.source_type;
    return /*#__PURE__*/ _jsxs(MainPreviewModalWrapper, {
        onClick: onClose,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "left-align",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        onClick: (e)=>e.stopPropagation(),
                        children: [
                            currentProduct === null || currentProduct === void 0 ? void 0 : currentProduct.title
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "image-list",
                        onClick: (e)=>e.stopPropagation(),
                        children: [
                            !currentProduct && /*#__PURE__*/ _jsx(DefaultLoadingContainer, {
                                title: "데이터를 불러오는 중입니다."
                            }),
                            (!(source === null || source === void 0 ? void 0 : (_source_images = source.images) === null || _source_images === void 0 ? void 0 : _source_images.previews) || (source === null || source === void 0 ? void 0 : (_source_images1 = source.images) === null || _source_images1 === void 0 ? void 0 : _source_images1.previews.length) === 0) && /*#__PURE__*/ _jsx(EmptyContainer, {
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    variant: "body1",
                                    color: "rgba(106, 112, 138, 1)",
                                    children: "등록된 샘플이 없어요."
                                })
                            }),
                            source === null || source === void 0 ? void 0 : (_source_images2 = source.images) === null || _source_images2 === void 0 ? void 0 : _source_images2.previews.map((image, index)=>/*#__PURE__*/ _jsx(Image, {
                                    width: 788,
                                    height: 1124,
                                    src: image.url,
                                    alt: ""
                                }, index))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "cart-wrapper",
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        className: "close-button",
                        onClick: ()=>{
                            onClose();
                            mixpanelEvent("Close UI", {
                                Type: "닫기버튼",
                                Position: "preview modal"
                            });
                        },
                        children: /*#__PURE__*/ _jsx(Icon, {
                            icon: Close
                        })
                    }),
                    productType === "handout" ? /*#__PURE__*/ _jsx(PurchaseSection, {
                        product: currentProduct,
                        isLoggedIn: isLoggedIn,
                        hasUsableFreepass: hasUsableFreepass,
                        freeTrialData: freeTrialData !== null && freeTrialData !== void 0 ? freeTrialData : undefined,
                        isFreeTrialLoading: isFreeTrialLoading,
                        isInModal: true
                    }) : /*#__PURE__*/ _jsx(PriceSection, {
                        product: currentProduct
                    })
                ]
            })
        ]
    });
};
const EmptyContainer = muiStyled("div")((param)=>{
    let { theme  } = param;
    return {
        backgroundColor: theme.palette.background.paper,
        borderRadius: "6px",
        // margin: '0 auto',
        width: "revert-layer",
        height: "100%",
        flex: "1 1 auto",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    };
});
const MainPreviewModalWrapper = styled.div.withConfig({
    componentId: "sc-4e106fe4-0"
})(_templateObject());
